import api from './api';

class ConfigurationService {
    async getDefaultConfigurations(){
        return api.get('/settings/configurations/default');
    }

    async getDataConfigurations(){
        return api.get('/setting/organization/information');
    }
    updateDataConfigurations(data) {
        if(data){
            return api
                .put("/setting/organization/information", data)
                .then((response) => {
                    return response;
                });
        }
    }   
}

export default new ConfigurationService();
